import { Badge, Card, Col, Row } from "react-bootstrap"
import timeService from "../../services/time/timeService"

interface TimezoneSettingsProps {
  onTimezoneRefresh: () => void
}

export default function TimezoneSettings({
  onTimezoneRefresh
}: TimezoneSettingsProps) {
  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title className="mb-0">Timezone Settings</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm={4} md={2}><strong>Timezone:</strong></Col>
          <Col sm={8}>
            {timeService.liveZone} <small>({timeService.hoursOffset} hours)</small>
            <Badge
              role="button"
              bg="secondary"
              className="ms-2"
              onClick={onTimezoneRefresh}
            >
              Refresh
            </Badge>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}